import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { CurrencyMaskModule } from "ng2-currency-mask";
import { DirectivesModule } from "src/app/directives/directives.module";
import { ApgQuickQuoteHeaderComponent } from "../apg-quick-quote/apg-quick-quote-header/apg-quick-quote-header.component";
import { ApgQuickQuoteOtpComponent } from "../apg-quick-quote/apg-quick-quote-otp/apg-quick-quote-otp.component";
import { ValidateOtpComponent } from "../apg-quick-quote/apg-quick-quote-otp/validate-otp/validate-otp.component";
import { VerifyOtpComponent } from "../apg-quick-quote/apg-quick-quote-otp/verify-otp/verify-otp.component";
import { ApgQuickQuoteNotesComponent } from "./apg-quick-quote-notes/apg-quick-quote-notes.component";
import { ApgQuickQuoteResultComponent } from "./apg-quick-quote-result/apg-quick-quote-result.component";
import { ExpandableTableRowComponent } from "./expandable-table-row/expandable-table-row.component";
import { ExpanderComponent } from "./expander/expander.component";
import { HelpPopupComponent } from "./help-popup/help-popup.component";
import { InfoBlockComponent } from "./info-block/info-block.component";
import { PagingComponent } from "./paging/paging.component";
import { AppCentsPipe } from "./pipes/app-cents.pipe";
import { AppCurrencyPipe } from "./pipes/app-currency.pipe";
import { OrdinalSuffixPipe } from "./pipes/app-ordinal-suffix";
import { AppPoundsPipe } from "./pipes/app-pounds-pipe";
import { AppShortCurrencyPipe } from "./pipes/app-short-currency.pipe";
import { SafeHtmlPipe } from "./pipes/safe-html.pipe";
import { TimeFormatPipe } from './pipes/time-format.pipe';
import { QuestionnaireSummaryComponent } from "./questionnaire-summary/questionnaire-summary.component";
import { SiteContentComponent } from "./site-content/site-content.component";
import { SummaryRowComponent } from "./summary-row/summary-row.component";

const components = [
  QuestionnaireSummaryComponent,
  SummaryRowComponent,
  InfoBlockComponent,
  PagingComponent,
  ApgQuickQuoteResultComponent,
  SiteContentComponent,
  ExpanderComponent,
  ExpandableTableRowComponent,
  HelpPopupComponent,
  ApgQuickQuoteNotesComponent,
  ApgQuickQuoteHeaderComponent,
  ApgQuickQuoteOtpComponent,
  ValidateOtpComponent,
  VerifyOtpComponent
];

const pipes = [
  AppCurrencyPipe,
  AppShortCurrencyPipe,
  TimeFormatPipe,
  AppCentsPipe,
  AppPoundsPipe,
  SafeHtmlPipe,
  OrdinalSuffixPipe
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    DirectivesModule,
    NgxSliderModule,
    CurrencyMaskModule
  ],
  providers: [
    ...pipes
  ],
  exports: [
    ...components,
    ...pipes
  ],
  declarations: [
    ...components,
    ...pipes
  ]
})
export class SharedModule { }

